<template>
  <CSidebar
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
     style="background-color: white !important; color: black !important;"
  >
    <CSidebarBrand class="d-md-down-none" to="/" style="background-color: #FFF !important;">
      <div style="margin: auto;"><img src="logo_horizontal.png" style="height: 59px; margin: 15px;"/></div>
    </CSidebarBrand>
    <CRenderFunction flat :contentToRender="menu"/>
  </CSidebar>
</template>

<script>
import ws from '../services/general';
export default {
  name: 'TheSidebar',
  data: function () {
		return {
        menu: []
    }
  },
  mounted: async function() {
      let menu = [];

      let response = await ws.getMenu("sitebar"); 

      if(response.type == "success"){
        const renderedMenu = [];

        response.data.forEach(item => {
          if(item.is_grouper){
            renderedMenu.push({_name: 'CSidebarNavTitle', _children: [item.label]});
          }
          else{
            renderedMenu.push({_name: 'CSidebarNavItem',name: item.label, to: item.target, icon: item.icon});
          }
        });

        menu = renderedMenu;
      }

      this.menu = [{
        _name: 'CSidebarNav',
        _attrs: { style: 'color: #000;' },
        _children: menu
      }];
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    }
  }
}
</script>

